export class StyleComboDto {
    styleComboid: number; 
    combination?:string;
    primaryColor?:string;
    itemColor?: string;
    createdUser?: string;
    isActive?:boolean
    versionFlag?: number;
    updatedUser?:string;
    updatedAt?:string;
    
    constructor(styleComboid: number,combination?:string, primaryColor?:string,itemColor?: string,
    createdUser?:string,isActive?:boolean,versionFlag?: number,updatedUser?:string,
     updatedAt?:string) {
      this.styleComboid = styleComboid;
      this.combination = combination;
      this.primaryColor = primaryColor;
      this.itemColor = itemColor;
      this.createdUser = createdUser;
      this.isActive = isActive;
      this.versionFlag = versionFlag;
      this.updatedUser = updatedUser;
      this.updatedAt = updatedAt;

    }
  }
  